module.exports = __webpack_public_path__ + "static/media/venmo.1f5acc90.svg";